import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Wed, 6 Sep 2024 8:47PM ( BRT ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.uM6XhXqqtZGERiX9X9AozjkahmHsoWDEtXc050OFQHxyLcEtceuX6INj6jsavtsquvX258gtreuRiV4k_yUgMM6HyMRBahLO6jqKzFkHZ99GkOoPqh4ssKcY0Qw_z53H7MxSknztXMRJO3a8JWVDhD6B1aXS-Dv41wCCLTf-MdNAvQ5AkE5u_C38pJC1s1qoAB-4qfdRl9fTTo-nyPR0801lJUF33czPmL3yjVaMBlqGueEwgwv6BmCyWBHGuhbA4Ilg-ZAqDPbT8Nd0wlhj4HGod29Lp-U",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-09-13T23:46:20.665859Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2024-09-06T23:46:06+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.uM6XhXqqtZGERiX9X9AozjkahmHsoWDEtXc050OFQHxyLcEtceuX6INj6jsavtsquvX258gtreuRiV4k_yUgMM6HyMRBahLO6jqKzFkHZ99GkOoPqh4ssKcY0Qw_z53H7MxSknztXMRJO3a8JWVDhD6B1aXS-Dv41wCCLTf-MdNAvQ5AkE5u_C38pJC1s1qoAB-4qfdRl9fTTo-nyPR0801lJUF33czPmL3yjVaMBlqGueEwgwv6BmCyWBHGuhbA4Ilg-ZAqDPbT8Nd0wlhj4HGod29Lp-U'

// {
//   "access_token": "v2.local.dLNaZ3C01xZKVYcnk023tBaqL5S72CWkrWy4EK9jHbGkVIBJuTPy3hLDvFJTtDgAsfCP_-95xM76EzGuoIF1xezA1kIl9fx_MTHLzinMX1jKr0bybW_MJCF-p0Nnw1OGozlLxeArz2Fms78__OS1rGYsmukpwFh7nbmxaIDPpuejZAoE1YmcrrbIY-grNbCZuqpRY3t-QtGLKi1DOPYoZXO3XOt6oH84NgX9kd-m79UYLdAGkk7D0HObJmrwHWb0YMg9ZXmVP_ZwSO-56G_l70xAomfEOe8",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-09-13T23:48:24.072756Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2024-09-06T23:48:06+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.dLNaZ3C01xZKVYcnk023tBaqL5S72CWkrWy4EK9jHbGkVIBJuTPy3hLDvFJTtDgAsfCP_-95xM76EzGuoIF1xezA1kIl9fx_MTHLzinMX1jKr0bybW_MJCF-p0Nnw1OGozlLxeArz2Fms78__OS1rGYsmukpwFh7nbmxaIDPpuejZAoE1YmcrrbIY-grNbCZuqpRY3t-QtGLKi1DOPYoZXO3XOt6oH84NgX9kd-m79UYLdAGkk7D0HObJmrwHWb0YMg9ZXmVP_ZwSO-56G_l70xAomfEOe8'

// {
//   "access_token": "v2.local.DtTqTMJOE8YIZujzp6nKP0zIn0d2gL4XOucnaJHJdVXhcVMYWjaTrKNLa4F7nzECq5C-BQuQORMmlWJiNInYl0t88ch9cjD_8Rz53tVAWvW9WkPEme7e-Mu5d0c-CRPT8Ys42Cao3PLKCEpbBow1sEj3PgYtP3W4gXaAzirVOt39ZYybilbWYvbMrTlvrl0sNsfGKyFEjCFEGbFAU4PtxgH3oOf8uzD3FrFt-ZvJf23-Gj0hmg_fFRuBSto48I1iDBBa3yRjEWdDFEoQT0LrpuackjBM",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2024-09-13T23:50:00.054116Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.DtTqTMJOE8YIZujzp6nKP0zIn0d2gL4XOucnaJHJdVXhcVMYWjaTrKNLa4F7nzECq5C-BQuQORMmlWJiNInYl0t88ch9cjD_8Rz53tVAWvW9WkPEme7e-Mu5d0c-CRPT8Ys42Cao3PLKCEpbBow1sEj3PgYtP3W4gXaAzirVOt39ZYybilbWYvbMrTlvrl0sNsfGKyFEjCFEGbFAU4PtxgH3oOf8uzD3FrFt-ZvJf23-Gj0hmg_fFRuBSto48I1iDBBa3yRjEWdDFEoQT0LrpuackjBM'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
